/** Live account registration – use for every “Open account” / “Start trading” CTA */
export const REGISTER_URL = "https://secure.abetglobal.com/account/register";

/** Client portal login (secure domain) */
export const CLIENT_LOGIN_URL = "https://secure.abetglobal.com/account/login";

/** Web Trader (Trading → Platforms) */
export const WEB_TRADER_URL = "https://webtrading.abetglobal.com/";

/** IB / partner portal */
export const PARTNERS_URL = "https://my.abetpartners.com/register";
